export const ROUTES = {
  LANDING: '/',
  MY_CLOSET: 'closet',
  TOPS: 'tops',
  BOTTOMS: 'bottoms',
  UPLOAD: 'upload',
  COMPARE: 'compare'
}
